import { createApp } from "vue";
import App from "./App.vue";
import router, { setupRouter } from "@/router";
import { setupStore } from "@/pinia";
import "element-plus/es/components/message/style/css";
import 'element-plus/es/components/message-box/style/css'
import VueUeditorWrap from 'vue-ueditor-wrap';
import 'element-plus/theme-chalk/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(setupStore).use(setupRouter).use(VueUeditorWrap).mount("#app");
